<template>
  <v-card
    class="d-flex flex-column align-center mx-auto py-4"
    max-width="600"
    outlined
  >
    <v-card-text>Estableciendo la conexión a Twitter ...</v-card-text>
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </v-card>
</template>
<script>
export default {
  mounted() {
    this.$nextTick(() => {
      //http://localhost:9090/twitter/ok?oauth_token=pdcexgAAAAAA2FeMAAABdPbQSQc&oauth_verifier=m8hlx1KEjerXNbpYklmYWSQdVBWyngUu&oauth_token=pdcexgAAAAAA2FeMAAABdPbQSQc
      const urlParams = new URLSearchParams(window.location.search);
      const oauthToken = urlParams.get("oauth_token");
      const oauthVerifier = urlParams.get("oauth_verifier");
      console.log("oauthToken", oauthToken);
      console.log("oauthVerifier", oauthVerifier);
      this.$http
        .post("/api/oauth/twitter/ok", {
          oauthToken,
          oauthVerifier,
        })
        .then((response) => {
          console.log(response);
          this.$router.push({ path: "/profile" });
          if (window) {
            window.close();
          }
        });
    });
  },
};
</script>